import {
	BsEnvelope,
	BsTelephone,
	BsPeople,
	BsRobot,
	BsSend,
	BsLinkedin,
	BsCalendar,
	BsBroadcast,
} from 'react-icons/bs';

/**
 * Maps the icon string stored in crmChannelTypes.icon (DB) to the actual
 * react-icons/bs component. Add new entries here when a new channel type
 * is created.
 */
const BS_ICON_MAP = {
	BsEnvelope,
	BsTelephone,
	BsPeople,
	BsRobot,
	BsSend,
	BsLinkedin,
	BsCalendar,
	BsBroadcast,
};

/**
 * Resolves a channel type's icon component from its DB icon string.
 * @param {object} channelType - A channel type object with an `icon` field (e.g. "BsEnvelope")
 * @returns {import('react').ComponentType} The resolved icon component, or BsBroadcast as fallback
 */
export function resolveChannelIcon(channelType) {
	if (!channelType?.icon) return BsBroadcast;
	return BS_ICON_MAP[channelType.icon] ?? BsBroadcast;
}
